import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Menu, Dropdown, Drawer } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import Logo from "../Assets/Logo.JPG";
import Chat from "../Components/Chat";

const Layout = (props) => {
    const history = useHistory()
    const [visible, setVisible] = useState(false);
    const [ChatShow, setChatShow] = useState(false)

    const showDrawer = () => {
        setVisible(true);
    };
    const onClose = () => {
        setVisible(false);
    };


    const OnLogOut = () => {
        localStorage.setItem('MS-Login', false)
        localStorage.setItem('MS-AdminId', '')
        history.push('/')
    }

    const ServiceMenu = (
        <Menu>
            <Menu.Item key="0">
                <h3 onClick={() => history.push('/LocalMoving')} className='Menu-list-hover'> Local Moving </h3>
            </Menu.Item>
            <Menu.Item key="1">
                <h3 onClick={() => history.push('/LongDistanceMoving')} className='Menu-list-hover'> Long Distance Moving </h3>
            </Menu.Item>
            <Menu.Item key="2">
                <h3 onClick={() => history.push('/CommercialMoving')} className='Menu-list-hover'> Commercial Moving </h3>
            </Menu.Item>
            <Menu.Item key="3">
                <h3 onClick={() => history.push('/MilitaryMoving')} className='Menu-list-hover'> Military Moving </h3>
            </Menu.Item>
            <Menu.Item key="4">
                <h3 onClick={() => history.push('/PianoAndAntique')} className='Menu-list-hover'> Piano And Antique </h3>
            </Menu.Item>
            <Menu.Item key="5">
                <h3 onClick={() => history.push('/Storage')} className='Menu-list-hover'> Storage </h3>
            </Menu.Item>
            <Menu.Item key="6">
                <h3 onClick={() => history.push('/PackingAndUnpacking')} className='Menu-list-hover'> Packing And UnPacking </h3>
            </Menu.Item>
        </Menu>
    );

    const Resources = (
        <Menu>
            <Menu.Item key="0">
            <h3 onClick={() => history.push('/MovingPlanner')} className='Menu-list-hover'> Moving Planner </h3>
            </Menu.Item>
            <Menu.Item key="0">
                <h3 onClick={() => history.push('/FormView')} className='Menu-list-hover'> Form Queries </h3>
            </Menu.Item>
        </Menu>
    );

    const SiderBar = () => {
        return (
            <div className='Nav-BarMenu'>
                <i onClick={showDrawer} class="fas fa-bars"></i>
                <Drawer placement="right" closable={false} onClose={onClose} visible={visible}>
                    <div className='Nav-menu-list-res Nav-List'>
                    <h3 onClick={OnLogOut} className='logout-btn'>Log Out</h3>
                        <h3 onClick={() => history.push('/Home')}>Home</h3>
                        <h3 onClick={() => history.push('/LocalMoving')} style={{ textAlign: 'center' }} > Local Moving </h3>
                        <h3 onClick={() => history.push('/LongDistanceMovingTips')} style={{ textAlign: 'center' }}> Long Distance Moving Tips </h3>
                        <h3 onClick={() => history.push('/LongDistanceMoving')} style={{ textAlign: 'center' }}> Long Distance Moving </h3>
                        <h3 onClick={() => history.push('/CommercialMoving')} style={{ textAlign: 'center' }}> Commercial Moving </h3>
                        <h3 onClick={() => history.push('/MilitaryMoving')} style={{ textAlign: 'center' }}> Military Moving </h3>
                        <h3 onClick={() => history.push('/PianoAndAntique')} style={{ textAlign: 'center' }}> Piano And Antique </h3>
                        <h3 onClick={() => history.push('/PackingAndUnpacking')} style={{ textAlign: 'center' }}> Packing And UnPacking </h3>
                        <h3 onClick={() => history.push('/AboutUs')} style={{ textAlign: 'center' }}>About us</h3>
                        <h3 onClick={() => history.push('/Storage')} style={{ textAlign: 'center' }}> Storage </h3>
                        <h3 onClick={() => history.push('/FAQs')} style={{ textAlign: 'center' }}>FAQ's</h3>
                        <h3 onClick={() => history.push('/Blogs')} style={{ textAlign: 'center' }}>Blog</h3>
                        <h3 onClick={() => history.push('/FormView')} style={{ textAlign: 'center' }}>Form Queries</h3>
                    </div>
                </Drawer>
            </div>
        )
    }

    return (
        <div>
            <div className='NavBar'>
                <div className='Nav-Logo' >
                    <img src={Logo} alt='Moving Site' onClick={()=> history.push('/Home')} draggable={false} />
                </div>
                <div className='Nav-menu' >
                    <div className='Nav-menu-list'>
                        <h3 onClick={() => history.push('/Home')}>Home</h3>
                        <Dropdown overlay={ServiceMenu}>
                            <h3 className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                                Moving Services <DownOutlined className="Arrow-Down-menu" />
                            </h3>
                        </Dropdown>
                        <Dropdown overlay={Resources}>
                            <h3 className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                                Resources <DownOutlined className="Arrow-Down-menu" />
                            </h3>
                        </Dropdown>
                        <h3 onClick={() => history.push('/FAQs')}>FAQ's</h3>
                        <h3 onClick={() => history.push('AboutUs')}>About us</h3>
                        <h3 onClick={() => history.push('Blogs')} >Blog</h3>
                        <h3 onClick={OnLogOut} className='logout-btn'>Log Out</h3>
                    </div>
                </div>
                <SiderBar />
            </div>
            {props.children}

            <div className='Chat-Icon' onClick={()=> setChatShow(!ChatShow)}>
            <i class="far fa-comment-dots"></i>
            </div>
            {ChatShow && <Chat /> }

            <div className='Footer'>
                <div className='Footer-section'>
                    <div className='Footer-sec-left'>
                        <img src={Logo} alt='Moving Site' onClick={()=> history.push('/Home')} draggable={false} />
                         <a href='tel: 844-346-2264'>
                            <div className='Toll-div'>
                                <h2 className='H1'>TOLL FREE</h2>
                                <h2 className='H2'>844-346-2264</h2>
                            </div>
                            </a>
                        {/* <p> Call us to receive a Free Estimate On Your Move (844)-346-2264 </p> */}
                        <div className='Social-link-footer'>
                            <i class="fab fa-facebook fb"></i>
                            <i class="fab fa-instagram dribble"></i>
                        </div>
                    </div>
                    <div className='Footer-sec-right'>
                    <div className='sec-box-left1'>
                            {/* <h3>CONTACT INFO</h3>
                            <h4>Address</h4>
                            <a target='_blank' href='https://www.google.com/maps/place/7756b+NW+44th+St,+Sunrise,+FL+33351,+USA/@26.1791466,-80.2564289,17z/data=!3m1!4b1!4m5!3m4!1s0x88d90674d3a156cf:0x7a5f2ed56c909752!8m2!3d26.1791466!4d-80.2542402'>7756B N W 44th Street Sunrise FL 33351</a>
                            <h4>Email</h4>
                            <a href='mailto: info@onthegorelocation.com'>info@onthegorelocation.com</a>
                            <h4>Phone</h4>
                            <a href='tel: 844-346-2264'>844 346 2264</a> */}
                        </div>
                        <div className='sec-box-left'>
                            <h3>About company</h3>
                            <p onClick={() => history.push('/OurService')}>Our Service</p>
                            <p onClick={() => history.push('/LocalMoving')}>Local Moving</p>
                            <p onClick={() => history.push('/LongDistanceMoving')}>Long Distance Moving</p>
                            <p onClick={() => history.push('/LocalMoving')}>Piano and Artwork</p>
                            <p onClick={() => history.push('/LocalMoving')}>Moving and Storage</p>
                        </div>
                        <div className='sec-box-right'>
                            <h3>Support System</h3>
                            <p onClick={() => history.push('/AboutUs')}>About us</p>
                            <p onClick={() => history.push('/Testimonials')}>Testimonials </p>
                            <p onClick={() => history.push('/ContactUs')}>Support</p>
                            <p onClick={() => history.push('/ContactUs')}>Contact</p>
                            <p onClick={() => history.push('/Blogs')}>Blog</p>
                        </div>
                    </div>
                </div>
                <div className='PlanLine'>
                    <div></div>
                </div>
                <div className='Footer-copyright'>
                    <p>Copyright © 2021 On The Go Relocation Services | MC 1184255 U.S. DOT 3543834</p>
                    <div className='Footer-privacy'>
                        <p onClick={() => history.push('/socialMediaPolicy')}>Social Media Policy</p>
                        <p onClick={() => history.push('/PrivacyPolicy')}>Privacy Policy</p>
                        <p onClick={() => history.push('/Copyright')}>Copyright</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Layout
